<template>
  <div v-show="props.visible" class="page-modal">
    <div class="page-modal_header flex-row justify-end mb-4">
      <img
        class="back cursor-pointer"
        :src="getBrandImageUrl('close_icon.png')"
        alt=""
        @click="back"
      />
    </div>
    <div class="page-modal_content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { modalController } from "@ionic/vue";
import { defineEmits, defineProps } from "vue";
import { getBrandImageUrl } from "@/js/brandImages";

interface PropsData {
  bgColor: "white" | "grey";
  visible: boolean;
  type?: string;
}

const props = defineProps<PropsData>();
const emit = defineEmits(["onFinish"]);

function back() {
  if (props.type === "vocabularyTest") {
    emit("onFinish");
    return;
  }
  modalController.dismiss();
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.page-modal {
  width: 100%;
  height: 100%;
  background-color: var(--font-white);

  &_content {
    width: 100%;
    height: calc(100% - 9.5vh - 8vw);
    padding: 0 1vw 5vh;
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  &_header {
    padding: 2vh 5vw 0;
  }

  .back {
    height: 2.8vh;
  }
}
</style>
